import { FetchCaseAppealListParams } from "../../../data-model/caseAppealsTable";
import { FilterValues } from "../../../data-model/filterValues";
import { mergeSearchFiltersWithSidebarFilters } from "./buildAppealSearchFilters";
import { processAppealFilterData } from "./processAppealFilterData";

/**
 * Builds the `pharmacy/appeal/list` request body for the current filters and search term.
 *
 * With no search term the legacy column->values map is sent unchanged. With one,
 * filters and search go up as a single predicate tree plus `case_sensitive: false`,
 * which is what makes matching case-insensitive server-side.
 *
 * @param validFilters - Applied table filters from Redux
 * @param searchTerm - Current search text (empty when not searching)
 * @param pageSize - Page size sent as `limit`
 * @param page - Page number to request (1-indexed)
 * @returns FetchCaseAppealListParams: Request body for the appeal list API
 */
export const buildAppealListPayload = (
  validFilters: FilterValues[],
  searchTerm: string,
  pageSize: number,
  page: number = 1,
): FetchCaseAppealListParams => {
  const { filters: apiFilters } = processAppealFilterData(validFilters);
  const hasSearchTerm = (searchTerm ?? "").trim().length > 0;

  if (hasSearchTerm) {
    return {
      filters: mergeSearchFiltersWithSidebarFilters(searchTerm, apiFilters),
      case_sensitive: false,
      page,
      limit: pageSize,
    };
  }

  return {
    filters: apiFilters,
    page,
    limit: pageSize,
  };
};
